import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isAuthenticated } from "../../services/auth";
import { Tooltip, message, Card, Button } from "antd";
import moment from "moment";
import "moment/locale/pt-br";
import {
  singleProduct,
  addFavourite,
  removeFavourite,
  favouriteCount,
} from "../../services/product";
import ProductComments from "../../components/product/product-comments";
import { viewUser } from "../../services/user";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ImageGallery from "react-image-gallery";
import RelatedProducts from "../../components/product/related-product";
import { useDispatch } from "react-redux";

moment.locale("pt-br");

const API = process.env.REACT_APP_API.replace("/api", "");

const ViewProduct = ({ match, history }) => {
  const dispatch = useDispatch();

  const [product, setProduct] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [productLocation, setProductLocation] = useState([]);
  const [productAuthor, setProductAuthor] = useState([]);
  const [productAuthorName, setProductAuthorName] = useState([]);
  const [productReports, setProductReports] = useState([]);
  const [reported, setReported] = useState(false);
  const [category, setCategory] = useState("");
  const [favourites, setFavourites] = useState([]);
  const [favourite, setFavourite] = useState(false);
  const [favCount, setFavCount] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [propertyDetails, setPropertyDetails] = useState({
    propertyType: "",
    bedrooms: "",
    bathrooms: "",
    garages: "",
  });

  const { user, token } = isAuthenticated();

  useEffect(() => {
    loadProduct();
    loadUser();
    loadFavouriteCount();

    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initial check

    return () => window.removeEventListener("resize", handleResize);
  }, [favourite, reported, match.params.productId]);

  const loadUser = async () => {
    if (user && token) {
      const res = await viewUser(user._id);
      setFavourites(res.data.favourites);
    }
  };

  const loadProduct = async () => {
    // Fetch product, include auth token to get private fields for owner
    const res = await singleProduct(match.params.productId, token);
    if (res.data) {
      setProduct(res.data);
      if (res.data.category) {
        setCategory(res.data.category);
      } else {
        setCategory({ name: "Categoria desconhecida", _id: "" });
      }
      if (res.data.location) {
        setProductLocation(res.data.location);
      } else {
        setProductLocation({ name: "Localização desconhecida", _id: "" });
      }
      if (res.data.author) {
        setProductAuthor(res.data.author);
        setProductAuthorName(res.data.author.name);
      } else {
        setProductAuthor(null);
        setProductAuthorName("Usuário desconhecido");
      }
      // Corrija aqui: monte a URL completa para cada imagem
      var imageArray = res.data.images.slice(0).map((item, index) => ({
        original: `${API}${item}`,
        thumbnail: `${API}${item}`,
      }));
      setProductImages(imageArray);

      const reportArray = [];
      res.data.reports.map((item) => reportArray.push(item.author));
      setProductReports(reportArray);

      // Set property details
      setPropertyDetails({
        propertyType: res.data.propertyType || "",
        bedrooms: res.data.bedrooms || "",
        bathrooms: res.data.bathrooms || "",
        garages: res.data.garages || "",
      });

      dispatch({
        type: "PRODUCT_DETAILS",
        payload: res.data.category,
      });
    } else {
      // Handle case where product not found or error
      setProduct({
        name: "Produto não encontrado",
        _id: "",
        price: 0,
        description: "",
        condition: "",
        status: "",
        createdAt: null,
        updatedAt: null,
        privateObservation: "",
        privatePhone: "",
      });
      setCategory({ name: "Categoria desconhecida", _id: "" });
      setProductLocation({ name: "Localização desconhecida", _id: "" });
      setProductAuthor(null);
      setProductAuthorName("Usuário desconhecido");
      setProductImages([]);
      setProductReports([]);
    }
  };

  const loadFavouriteCount = async () => {
    const res = await favouriteCount(match.params.productId);
    setFavCount(res.data);
  };

  const handleAddFavourite = async (productId) => {
    const res = await addFavourite(productId, { user, token });
    console.log(res.data);
    message.success("Adicionado aos Favoritos");
    setFavourite(!favourite);
  };
  const handleRemoveFavourite = async (productId) => {
    const res = await removeFavourite(productId, { user, token });
    console.log(res.data);
    setFavourite(!favourite);
  };

  //format currency
  Number.prototype.format = function (n, x) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
  };

  const translateCondition = (condition) => {
    switch (condition) {
      case "New":
        return "Novo";
      case "Used":
        return "Usado";
      case "not_applicable":
        return "Não aplicável";
      default:
        return condition;
    }
  };

  const translateStatus = (status) => {
    switch (status) {
      case "active":
        return "Ativo";
      case "inactive":
        return "Inativo";
      case "pending":
        return "Pendente";
      default:
        return status;
    }
  };

  const renderAuthorCard = () => (
    <div className="author-card">
      <div className="product-header-sidebar">
        <h3 className="product-name-sidebar">{product.name}</h3>
        <span className="product-price-sidebar">
          {product && typeof product.price === "number"
            ? product.price.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            : "R$ 0,00"}
        </span>
      </div>

      <div className="seller-info">
        <p className="seller-label">Vendedor</p>
        {productAuthor ? (
          <Link
            to={`/user/${productAuthor._id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="author-avatar">
              {productAuthor && productAuthor.photo ? (
                <img
                  src={`${process.env.REACT_APP_API.replace(/\/api$/, "")}${
                    productAuthor.photo
                  }`}
                  alt={productAuthorName}
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#e0e7ff",
                    color: "#3730a3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  {productAuthorName[0]}
                </div>
              )}
            </div>
          </Link>
        ) : (
          <div className="author-avatar">
            {productAuthor && productAuthor.photo ? (
              <img
                src={`${process.env.REACT_APP_API.replace(/\/api$/, "")}${
                  productAuthor.photo
                }`}
                alt={productAuthorName}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  backgroundColor: "#e0e7ff",
                  color: "#3730a3",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                {productAuthorName[0]}
              </div>
            )}
          </div>
        )}
        <div className="author-info">
          {productAuthor ? (
            <Link
              to={`/user/${productAuthor._id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <h4>{productAuthorName}</h4>
            </Link>
          ) : (
            <h4>{productAuthorName}</h4>
          )}
        </div>
      </div>
      {productAuthor && productAuthor.phone && (
        <a
          href={`https://wa.me/55${productAuthor.phone.replace(
            /\D/g,
            ""
          )}?text=Me%20interessei%20neste%20produto:%20${window.location.href}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
        >
          <i className="fab fa-whatsapp"></i> {productAuthor.phone}
        </a>
      )}
      {user && productAuthor && user._id !== productAuthor._id && (
        <div className="author-actions">
          <Link to={`/user/${productAuthor._id}`}>
            <Button type="primary" block>
              Ver Perfil
            </Button>
          </Link>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className="view-product-container">
        <div className="view-product-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/" className="text-decoration-none">
                Início
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/category/${category._id}`}
                className="text-decoration-none"
              >
                {category.name}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{product.name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="view-product-top-row">
          <div>
            <div className="view-product-gallery">
              <ImageGallery
                items={productImages}
                showPlayButton={false}
                showFullscreenButton={false}
                showThumbnails={productImages.length > 1}
                showBullets={productImages.length > 1}
                showNav={productImages.length > 1}
                lazyLoad={true}
                slideDuration={300}
                slideInterval={3000}
              />
            </div>
            <div className="view-product-main">
              {isMobile && renderAuthorCard()}
              <div className="view-product-info">
                <div className="view-product-details">
                  <div className="detail-row">
                    <span className="detail-label">Categoria:</span>
                    <span className="detail-value">{category.name}</span>
                  </div>

                  {propertyDetails.propertyType && (
                    <div className="detail-row">
                      <span className="detail-label">Tipo de Imóvel:</span>
                      <span className="detail-value">
                        {propertyDetails.propertyType}
                      </span>
                    </div>
                  )}

                  {propertyDetails.bedrooms && (
                    <div className="detail-row">
                      <span className="detail-label">Dormitórios:</span>
                      <span className="detail-value">
                        {propertyDetails.bedrooms}
                      </span>
                    </div>
                  )}

                  {propertyDetails.bathrooms && (
                    <div className="detail-row">
                      <span className="detail-label">Banheiros:</span>
                      <span className="detail-value">
                        {propertyDetails.bathrooms}
                      </span>
                    </div>
                  )}

                  {propertyDetails.garages && (
                    <div className="detail-row">
                      <span className="detail-label">Garagens:</span>
                      <span className="detail-value">
                        {propertyDetails.garages}
                      </span>
                    </div>
                  )}

                  {product && product.condition !== "" && (
                    <div className="detail-row">
                      <span className="detail-label">Condição:</span>
                      <span className="detail-value">
                        {translateCondition(product.condition)}
                      </span>
                    </div>
                  )}
                  <div className="detail-row">
                    <span className="detail-label">Status:</span>
                    <span className="detail-value">
                      {translateStatus(product.status)}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Localização:</span>
                    <Link
                      to={`/search-result?&city=${product.city?._id}&category=&name=&price=&condition=`}
                      className="detail-link"
                    >
                      {product.state}, {product.city?.name}{product.neighborhood ? `, ${product.neighborhood.name}` : ''}
                    </Link>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Anunciado:</span>
                    <span className="detail-value">
                      {product
                        ? moment(product.createdAt).fromNow()
                        : "Carregando..."}
                    </span>
                  </div>
                  {product && product.updatedAt && (
                    <div className="detail-row">
                      <span className="detail-label">Atualizado:</span>
                      <span className="detail-value">
                        {moment(product.updatedAt).fromNow()}
                      </span>
                    </div>
                  )}
                </div>

                <div className="view-product-description">
                  <h3>Descrição</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: product.description
                        ? product.description.replace(/\n/g, "<br />")
                        : "",
                    }}
                  />
                </div>

                {user && productAuthor && user._id === productAuthor._id && (
                  <div className="view-product-private-description">
                    <div className="private-section">
                      <h4>Informações Privadas</h4>
                      <div className="private-observation">
                        <strong>Observação:</strong>
                        <p>
                          {(product && product.privateObservation) || "Nenhuma"}
                        </p>
                      </div>
                      <div className="private-phone">
                        <strong>Telefone:</strong>
                        <div className="phone-actions">
                          <Button
                            type="primary"
                            icon={<i className="fab fa-whatsapp"></i>}
                            onClick={() =>
                              window.open(
                                `https://wa.me/55${(
                                  (product && product.privatePhone) ||
                                  ""
                                ).replace(/\D/g, "")}`,
                                "_blank"
                              )
                            }
                          >
                            WhatsApp
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="view-product-sidebar">
            {!isMobile && renderAuthorCard()}

            {process.env.REACT_APP_COMMENTS !== "false" && !isMobile && (
              <ProductComments productId={match.params.productId} />
            )}
          </div>
        </div>

        {process.env.REACT_APP_COMMENTS !== "false" && isMobile && (
          <ProductComments productId={match.params.productId} />
        )}

        {product && product._id && <RelatedProducts productId={product._id} />}
      </div>
    </>
  );
};

export default ViewProduct;
